<template>

	<div :class="{ modal: true }">

		<div class="modal-wrap">

			<div class="modal-inner ignore-full">

				<Loading v-if="loading!==''" position="inner" :text="loading" />

				<h2 class="modal-title">{{ showTitle }}<span class="close" @click="close()">X</span></h2>

				<div class="modal-inner-scroll ignore-full">

					<form class="form" @submit.prevent="submit">

						<h3 class="please-select" v-if="!selectedProject&&!id&&projectListAll.length>0">Please select a {{ projectNameLabel.toLowerCase() }} for your investigation...</h3>

						<h3 class="please-select" v-if="!selectedProject&&!id&&projectListAll.length===0">Please <router-link :to="isDataDive ? '/data-dive' : '/rank-tracking'" :title="projectNameLabel+'s Dashboard'">create a {{ projectNameLabel.toLowerCase() }}</router-link> first</h3>

						<div class="select-wrap" v-if="projectListAll.length>0">

							<label>{{ projectNameLabel }}</label>
							<v-select 
					            v-model="selectedProject" 
					            :options="projectListAll" 
					            :append-to-body="true"
								:reduce="option => option._id"
								:clearable="false"
								label="name"
								:disabled="!!id||projectListAll.length<2"
					        ></v-select>

					    </div>

						<div v-if="selectedProject">

							<h4 class="investigation-info-title" v-if="investigationInfo!==''">Investigating...</h4>
							<p v-html="investigationInfo" class="info" v-if="investigationInfo!==''" />

							<FormInput 
								type="text" 
								v-model="name"  
								name="name" 
								placeholder="Name your investigation"
								:required="false"
							/>

							<p v-html="description" class="notes" />

							<FormInput 
								type="textarea" 
								v-model="notes"  
								name="notes" 
								placeholder="Notes"
								:required="false"
								theRef="investigate-notes"
								:autoResize="true"
								:autoResizeMaxHeight="160"
							/>

							<p v-html="filterNameProcessed+' filter notes...'" class="notes" v-if="filterTipsProcessed" />
							<div class="filter-tips" v-html="filterTipsProcessed" v-if="filterTipsProcessed" />

							<div class="select-wrap">

								<label>Status</label>
								<v-select 
									v-model="status" 
									:options="statuses" 
									:append-to-body="true"
									:reduce="option => option.value"
									:clearable="false"
								/>

							</div>

							<div class="select-wrap" v-if="users.length>1">

								<label>Assigned To</label>
								<v-select 
									v-model="assignedTo" 
									:options="users" 
									:append-to-body="true"
									:reduce="option => option._id"
								/>

							</div>

							<p v-if="error!==''" class="error" v-html="error" />

							<span class="large-button" @click="submit" v-html="id ? 'Update' : 'Add'" />

						</div>

					</form>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import FormInput from './Form/Input.vue'
import Loading from './Loading.vue'
export default {
	name: 'Investigate',
	props: {
		theInvestigations: {
			type: Array
		},
		filter: {
			type: String,
			default: ''
		},
		project: {
			type: [String,Array],
			default: ''
		},
		id: {
			type: String
		},
		type: {
			type: String,
			default: 'general'
		},
		noProjectDisabled: {
			type: Boolean,
			default: false
		},
		filterTips: {
			type: String,
			defaukt: ''
		},
		filterName: {
			type: String,
			defaukt: ''
		},
		isDataDive: {
			type: Boolean,
			default: false
		}
	},
	components: {
		FormInput,
		Loading
	},
	watch: {
		selectedProject: function (a,b) {

			if ( a===b || !this.mountDone ) return;
			
			this.loadUsers(true);

		}
	},
	data() {

		return {
			loading: '',
			notes: '',
			status: 1,
			error: '',
			name: '',
			selectedProject: '',
			assignedTo: null, 
			users: [],
			filterTipsLoaded: '',
			investigations: [],
			filterNameLoaded: null,
			projectsDisabled: false,
			mountDone: false
		}

	},
	computed: { 

		...mapState('general',['tagsDescription','projectList']),

		filterTipsProcessed () {

			if ( this.filterTipsLoaded ) return this.filterTipsLoaded;
			return this.filterTips || '';

		},

		filterNameProcessed () {

			if ( this.filterNameLoaded ) return this.filterNameLoaded;
			return this.filterName || '';

		},

		projectListAll () {

			let projectListAll = [], filter = [];

			if ( this.project ) {

				if ( typeof this.project === 'string' ) {

					filter = [this.project];

				}
				else if ( Array.isArray( this.project ) ) {

					filter = this.project;

				}

			}

			this.projectList.forEach( function (p) {

				if ( this.isDataDive && ( !p.hasDataDive || !p.isDataDivePrimary ) ) return;

				if ( !this.isDataDive && ( !p.hasRankTracking || !p.active ) ) return;

				if ( filter.length > 0 && filter.indexOf( p._id.toString() ) < 0 ) return;

				projectListAll.push( { _id: p._id, name: this.isDataDive ? new URL(p.url).hostname : p.name } );

			}.bind(this));

			projectListAll.sort( (a,b) => {

				return a.name.localeCompare(b.name);

			});

			return projectListAll;

		},

		projectName () {

			let p = this.projectListAll.find( p => p._id === this.selectedProject );

			return p ? p.name : '';

		},

		projectNameLabel () {

			return this.isDataDive ? 'Domain' : 'Project';

		},

		description () {

			if ( this.id ) return "Your notes...";

			return this.filter !== '' ? "Are there any notes you'd like to add? <br />We will also add the notes from the filter you used which you can view in the Investigate area." : "Please add some notes below.";

		},

		showTitle () {

			return ( this.id ? 'Update' : 'Add' ) + " Investigation";

		},

		statuses () {

			return [{value:1,label:'Open'},{value:5,label:'In-Progress'},{value:10,label:'Complete'}]

		},

		investigationInfo () {

			let items = [], 
				investigations = this.theInvestigations ? this.theInvestigations : this.investigations;

			if ( investigations.length === 0 ) return '';

			if ( typeof investigations[0].keyword !== 'undefined' ) {

				if ( typeof investigations[0].url !== 'undefined' && typeof investigations[0].url === 'string' ) {

					let urls = {};

					investigations.forEach ( function (investigation) {

						console.log( investigation.url );

						if ( typeof urls[investigation.url] === 'undefined' ) urls[investigation.url] = [];

						urls[investigation.url].push( '<strong>' + investigation.keyword + '</strong>' );

					});

					Object.keys( urls ).forEach ( function ( url ) {

						items.push( this.joinAnd ( urls[url] ) + ' on <strong>' + url + '</strong>' );

					}.bind(this));

				}
				else {

					let keywords = [];

					investigations.forEach ( function (investigation) {

						keywords.push( '<strong>' + investigation.keyword + '</strong>' );

					});

					items.push( this.joinAnd ( keywords ) );

				}

				items = items.join('<br />');

			}
			else {

				investigations.forEach ( function (investigation) { items.push( '<strong>' + investigation.url + '</strong>' ) });

				items = this.joinAnd ( items );

			}

			return items + ' for <strong>' + this.projectName + '</strong>';

		}

    },
	methods: {

		...mapMutations('general',['updateLoadingText']),

		displayError(error) {

			this.errors = error ? error.message : '';

		},
		joinAnd (arr) {

			if ( arr.length < 2 ) return arr[0]; 

			let l = arr.pop();

			return arr.join(', ') + ' &amp; ' + l;

		},

		submit() {

			if ( this.name === '' ) {

				this.error = "Please name your investigation.";
				return;

			}

			if ( !this.status ) {

				this.error = "Please add a status.";
				return;

			}

			let info = {
				name: this.name,
				status: this.status,
				notes: this.notes,
				project: this.selectedProject
			};

			if ( this.assignedTo ) {

				info.assignedTo = this.assignedTo;

			}

			if ( typeof this.theInvestigations !== 'undefined' ) {

				info.type = this.type;
				info.investigations = this.theInvestigations;

				if ( this.filter === '' ) {

					if ( this.notes === '' ) {

						this.error = "Please add some notes to your investigation.";
						return;

					}

				}
				else {

					info.filter = this.filter;

				}

			}
			
			this.error = "";

			this.loading = this.id ? "Updating investigation" : "Adding investigation";

			ApiService.post( 'investigate' + ( this.id ? ( '/' + this.id ) : '' ), info )
			.then( function( info ) {

				this.loading = '';
				general.$snotify( this, 'success', 'Investigations', this.id ? "Your Investigation has been updated." : "Your Investigation has been added." );
				this.close(true);

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.error = "There was an error";

			}.bind(this));

		},

		close(update) {

			this.$emit('close',update);

		},
		loadUsers (noInv) {

			this.loading = 'One moment...';

			if ( !this.selectedProject ) {

				if ( !noInv ) this.loadInvestigation ();

				this.loading = '';
				
				return;

			}

			ApiService.get( 'projects/users/' + this.selectedProject )
			.then( function( info ) {

				this.users = info.data;

				if ( this.users.length > 0 && !this.id ) this.assignedTo = this.users[0]._id;

				if ( !noInv ) this.loadInvestigation ();
				else this.loading = '';

			}.bind(this))
			.catch( function(err) {

				this.loading = '';
				this.error = "There was an error";

			}.bind(this));

		},
		loadInvestigation () {
			
			if ( this.id ) {

				this.loading = 'One moment...';

				ApiService.get( 'investigate/' + this.id )
				.then( function( info ) {

					['notes', 'name', 'status', 'investigations', 'filterTips', 'filterName', 'assignedTo'].forEach ( function (t) {

						if ( typeof info.data[t] !== 'undefined' ) {

							let t2 = t;

							if ( t === 'filterTips' || t === 'filterName' ) t2 += 'Loaded';
							
							this[t2] = info.data[t];

						}

					}.bind(this));

					this.selectedProject = info.data.project;

					this.loading = '';

					this.mountDone = true;

				}.bind(this))
				.catch( function(err) {

					this.loading = '';
					this.error = "There was an error";

				}.bind(this));

			}
			else {

				this.mountDone = true;
				this.loading = '';

			}

		}
	},
	mounted() {

		if ( this.project && !Array.isArray( this.project ) ) {

			this.selectedProject = this.project;

			this.projectsDisabled = !this.noProjectDisabled;

		}

		this.loadUsers();

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
.modal {

	.modal-inner {

		&:before {

			display: none;

		}

		form {

			.please-select {

				margin-bottom: 15px;

				a, span {

					color: @formDefaultColour;

				}

			}

		}

		.filter-tips {

			border-radius: 5px;
		    border: 2px solid rgba(241, 73, 42, 0.3);
		    background-color: rgba(241, 73, 42, 0.03);
		    padding: 6px 14px;
		    margin-bottom: 30px;

		}

		.investigation-info-title {
			color: @formDefaultColour;
			margin-bottom: 3px;
		}

		p {
			padding: 0;
			margin: 0 0 20px 0;
			font-size: 14px;

			&.info {

				padding: 0;
				margin: 0 0 15px;
				color: @formDefaultColour;

			}

			&.notes {

				padding: 0;
				margin: 0 0 5px;

			}

			&.confirmed {

				margin: 30px;
				font-size: 18px;
				text-align: center;
				color: @formDefaultColour;

			}

			&.error {

				background-color: @red;
			    margin: 20px 0 0;
			    color: #fff;
			    padding: 10px;
			    border-radius: 5px;

			}
		}

	}

}
</style>